import React, { useState, useRef, useCallback, useEffect } from 'react';
import Webcam from 'react-webcam';
import { API_BASE_URL } from '../config';
import '../styles/Login.css';

export default function AutoRegistroFoto() {
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [fotoBase64, setFotoBase64] = useState(null);
    const [consentimientoAceptado, setConsentimientoAceptado] = useState(false);
    const webcamRef = useRef(null);

    useEffect(() => {
        // Obtener token de la URL
        const path = window.location.pathname;
        const parts = path.split('/auto-registro-foto/');
        if (parts.length > 1 && parts[1]) {
            setToken(parts[1]);
        } else {
            setError('Enlace inválido o incompleto.');
        }
    }, []);

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setFotoBase64(imageSrc);
    }, [webcamRef]);

    const retake = () => {
        setFotoBase64(null);
    };

    const handleUpload = async () => {
        if (!fotoBase64 || !token) return;

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/public/auto-registro-foto`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, fotoBase64, consentimiento_aceptado: consentimientoAceptado }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(true);
            } else {
                setError(data.error || 'Error al guardar la foto');
            }
        } catch (err) {
            setError('Error de conexión con el servidor');
        } finally {
            setLoading(false);
        }
    };

    const videoConstraints = {
        width: 400,
        height: 400,
        facingMode: "user"
    };

    if (success) {
        return (
            <div className="login-container">
                <div className="login-box" style={{ textAlign: 'center', maxWidth: '400px' }}>
                    <div style={{ fontSize: '4rem', marginBottom: '16px' }}>✅</div>
                    <h2 style={{ color: 'var(--text-main)', marginBottom: '16px' }}>¡Foto Registrada!</h2>
                    <p style={{ color: 'var(--text-muted)' }}>
                        Tu fotografía ha sido guardada exitosamente en tu ficha de personal.
                        Ya puedes cerrar esta ventana.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-box" style={{ maxWidth: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <h2 style={{ marginBottom: '8px' }}>Registro Fotográfico</h2>
                <p style={{ textAlign: 'center', color: 'var(--text-muted)', marginBottom: '24px', fontSize: '0.9rem' }}>
                    Por favor, tómate una foto clara de tu rostro. Evita usar lentes de sol o gorros.
                </p>

                {error && <div className="error-message" style={{ width: '100%', marginBottom: '16px' }}>{error}</div>}

                {token && !error && (
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {!consentimientoAceptado ? (
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    backgroundColor: 'var(--bg-secondary, #f8fafc)',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    marginBottom: '20px',
                                    border: '1px solid var(--border-light, #e2e8f0)'
                                }}>
                                    <h3 style={{ fontSize: '1rem', marginBottom: '12px', color: 'var(--text-main)' }}>
                                        Consentimiento para Tratamiento de Datos Biométricos
                                    </h3>
                                    <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: '1.6', marginBottom: '12px' }}>
                                        De conformidad con la <strong>Ley 21.719 de Protección de Datos Personales</strong> de Chile,
                                        se requiere su consentimiento expreso para el tratamiento de datos biométricos sensibles.
                                    </p>
                                    <ul style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: '1.8', paddingLeft: '20px', marginBottom: '12px' }}>
                                        <li>Se capturará una fotografía de su rostro para fines de identificación biométrica.</li>
                                        <li>Los datos biométricos serán almacenados de forma cifrada y segura.</li>
                                        <li>Su imagen será procesada mediante AWS Rekognition para verificación de identidad.</li>
                                        <li>Su RUT no será enviado a servicios externos (seudonimización).</li>
                                        <li>Puede ejercer sus derechos ARCO (acceso, rectificación, supresión, oposición, portabilidad) en cualquier momento.</li>
                                        <li>Puede revocar este consentimiento cuando lo estime conveniente.</li>
                                    </ul>
                                </div>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                    cursor: 'pointer',
                                    marginBottom: '20px',
                                    fontSize: '0.9rem',
                                    color: 'var(--text-main)'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={consentimientoAceptado}
                                        onChange={(e) => setConsentimientoAceptado(e.target.checked)}
                                        style={{ marginTop: '3px', width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span>He leído y acepto el tratamiento de mis datos biométricos según los términos descritos arriba.</span>
                                </label>
                                <button
                                    onClick={() => setConsentimientoAceptado(true)}
                                    className="login-button"
                                    style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                                >
                                    <span>✓</span> Acepto y Continuar
                                </button>
                            </div>
                        ) : !fotoBase64 ? (
                            <>
                                <div style={{ 
                                    borderRadius: '16px', 
                                    overflow: 'hidden', 
                                    boxShadow: 'var(--shadow-md)',
                                    marginBottom: '24px',
                                    border: '2px solid var(--border-light)',
                                    backgroundColor: '#000'
                                }}>
                                    <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={videoConstraints}
                                        style={{ width: '100%', maxWidth: '400px', display: 'block' }}
                                    />
                                </div>
                                <button 
                                    onClick={capture} 
                                    className="login-button" 
                                    style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                                >
                                    <span>📸</span> Tomar Foto
                                </button>
                            </>
                        ) : (
                            <>
                                <div style={{ 
                                    borderRadius: '16px', 
                                    overflow: 'hidden', 
                                    boxShadow: 'var(--shadow-md)',
                                    marginBottom: '24px',
                                    border: '2px solid var(--primary)',
                                }}>
                                    <img src={fotoBase64} alt="Captura" style={{ width: '100%', maxWidth: '400px', display: 'block' }} />
                                </div>
                                <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
                                    <button 
                                        onClick={retake} 
                                        className="btn-secondary" 
                                        style={{ flex: 1 }}
                                        disabled={loading}
                                    >
                                        Repetir
                                    </button>
                                    <button 
                                        onClick={handleUpload} 
                                        className="login-button" 
                                        style={{ flex: 1, margin: 0 }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Guardando...' : 'Guardar Foto'}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
